import React, { useState } from "react";
import { useSessionListenUrl } from "./hooks/useSessionListenUrl";
import { Copy } from "lucide-react";

export function CopySessionListenLinkButton() {
    const url = useSessionListenUrl();
    const [showTooltip, setShowTooltip] = useState(false);

    const handleShareLink = () => {
        navigator.clipboard.writeText(url);
        setShowTooltip(true);
        setTimeout(() => setShowTooltip(false), 1000);
    };

    return (
        <div className="relative">
            <button
                onClick={handleShareLink}
                className="flex items-center px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
                <Copy className="h-5 w-5 mr-2" />
                Copy Link
            </button>
            {showTooltip && (
                <div className="absolute top-full mt-2 left-1/2 transform -translate-x-1/2 bg-black text-white text-sm px-2 py-1 rounded shadow-lg whitespace-nowrap">
                    Link copied!
                </div>
            )}
        </div>
    );
}
